import React from 'react';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => {
  return <div className={`animate-shimmer rounded ${className}`} />;
};

export const BookCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <Skeleton className="aspect-[3/4] w-full" />
      <div className="p-2 sm:p-3 lg:p-4">
        <Skeleton className="h-4 sm:h-5 w-3/4 mb-2" />
        <Skeleton className="h-3 sm:h-4 w-1/2 mb-2" />
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
    </div>
  );
};

export const TableRowSkeleton: React.FC<{ columns?: number }> = ({ columns = 5 }) => {
  return (
    <tr>
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <Skeleton className="h-4 w-full" />
        </td>
      ))}
    </tr>
  );
};

export const BookDetailSkeleton: React.FC = () => {
  return (
    <div className="animate-fade-in">
      <Skeleton className="h-6 w-32 mb-6" />
      <div className="bg-white rounded-lg sm:rounded-xl shadow-sm p-4 sm:p-6 md:p-8">
        <div className="flex flex-col md:flex-row gap-4 sm:gap-6 md:gap-8">
          <div className="w-full max-w-[200px] mx-auto md:mx-0 md:w-64 lg:w-72">
            <Skeleton className="aspect-[3/4] w-full rounded-lg" />
          </div>
          <div className="flex-1 space-y-4">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-6 w-1/2" />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-8 w-24 rounded-full" />
              <Skeleton className="h-8 w-20 rounded-full" />
              <Skeleton className="h-8 w-28 rounded-full" />
            </div>
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-10 w-32" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const DashboardStatSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-lg sm:rounded-xl shadow-sm p-3 sm:p-4 lg:p-6 flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
      <Skeleton className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg" />
      <div className="text-center sm:text-left">
        <Skeleton className="h-7 w-12 mb-1" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  );
};
